<template>
    <footer>
        <div class="inner">
            <div class="container">
                <div class="row">
                    <div class="col-md-3 col-sm-6 widget">
                        <description></description>
                    </div>
                    <div class="col-md-3 col-sm-6 widget">
                        <news></news>
                    </div>
                    <div class="col-md-3 col-sm-6 widget">
                        <links></links>
                    </div>
                    <div class="col-md-3 col-sm-6 widget">
                        <contact></contact>
                    </div>
                </div>
            </div>
        </div>
        <subfooter></subfooter>
    </footer>
</template>

<script>
    import Description from './Description.vue';
    import News from './News.vue';
    import Links from './Links.vue';
    import Contact from './Contact.vue';
    import subfooter from '../subfooter/Subfooter.vue';
    export default {
        components : {
            'description' : Description,
            'news' : News,
            'links' : Links,
            'contact' : Contact,
            subfooter
        },
    };
</script>


// WEBPACK FOOTER //
// Footer.vue?5a5f3d62